import { IUserPortal } from 'interfaces/userinfo.interface';

/**
 * True only when some group in account2position holds at least one position.
 *
 * account2position lists GROUPS; a user's positions live in each group's nested
 * positions[] array. Checking account2position.length (the group count) is NOT the
 * same as having a position -- a pending user in a group with positions:[] has
 * length === 1 yet no assigned position.
 */
export const userHasAssignedPosition = (
  account: Partial<IUserPortal> | null | undefined
): boolean => {
  const groups = account?.account2position;
  if (!Array.isArray(groups)) return false;
  return groups.some((group) => Boolean(group.positions?.length));
};
